export const staticFilters = ["Nuevo", "Atender", "Cliente"];

export const replaceVars = (template, values) => {
	return template.replace(/\{\{(\w+)\}\}/g, (_, key) => {
		return values[key] ?? `{{${key}}}`;
	});
};
